<template>
  <div flat v-if="job">
    <v-app-bar flat tile>
      <v-app-bar-nav-icon @click="$emit('close')">
        <v-icon medium>close</v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title><span class="title  font-weight-bold">{{ $language.inviteWorkers['Invite workers'] }}</span></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon @click="share">
        <v-icon medium>share</v-icon>

      </v-app-bar-nav-icon>

    </v-app-bar>
    <!-- <v-flex mx-3 pt-2 text-xs-left>
        <div
          class="primary--text text-none my-2 ml-1"
          style="min-width: 125px; cursor: pointer"
          @click="selectAll"
          >
          {{ invitedWorkers.length === (favorites || []).length ? 'Clear selection' : 'Select all' }}
        </div>
      </v-flex> -->

    <v-list dense nav>
      <template v-for="item in (processFavorites(favorites || {}) || [])">
        <FavoriteListItem class="my-2" :key="item + job._key" :profileId="item" :job="job" :showAdd="true" :invite-me="inviteMe"></FavoriteListItem>
        <v-divider :key="item._key"></v-divider>
      </template>

    </v-list>
    <template >
      <v-container>
        <v-row justify="center">
          <v-col cols="10" justify="center" v-if="processFavorites(favorites || {}).length === 0" class="py-4">
            <span class="headline">{{$language.inviteWorkers['No Favorites']}}</span>
          </v-col>
          <v-col cols="10" class="py-4">
            <span>{{$language.inviteWorkers['Click']}} <v-icon class="pb-1 px-1">share</v-icon>{{$language.inviteWorkers['Upper Right']}}</span>
          </v-col>
          <v-col cols="10" class="py-4" v-if="!payoutsEnabled">
            <span>{{$language.inviteWorkers['Referral Agent']}} </span>
            <a href="/referrals">
              <span>{{$language.inviteWorkers['Learn More']}}</span>
            </a>
          </v-col>
        </v-row>

      </v-container>

    </template>
    <v-app-bar bottom fixed flat tile>
      <v-row no-gutters>
        <v-col cols="12">
          <v-btn large block text color="primary" @click="handleInviteAll">{{$language.jobDetails['Invite All']}}</v-btn>

        </v-col>

      </v-row>
    </v-app-bar>

    <v-snackbar v-model="snackbar.show" :color="status.error ? 'error' : 'success'" :timeout="1500">
      {{ snackbar.message }}

    </v-snackbar>
  </div>
</template>

<script>
import {
  mapState
} from 'vuex'
import FavoriteListItem from '@/components/jefe/FavoriteListItem'
const fb = require('@/services/firebaseConfig.js')

export default {
  props: ['job', 'favorites'],
  components: {
    FavoriteListItem
  },
  data () {
    return {
      status: {
        loading: false,
        error: false,
        message: ''
      },
      snackbar: {
        show: false,
        message: ''
      },
      sub: '',
      profile: {},
      invitedWorkers: [],
      inviteMe: null
    }
  },
  computed: {
    ...mapState(['userProfile', 'currentUser']),
    payoutsEnabled () {
      var pending = ((((this.userProfile || {}).stripeAccount || {}).account || {}).payouts_enabled || false)
      return pending
    }
  },

  watch: {
    favorites () {
      this.invitedWorkers = this.favorites
    }
  },

  methods: {
    share () {
      if (navigator.share) {
        navigator.share({
          title: 'Hefe App',
          text: 'Check out this job on Hefe. ',
          url: this.job.public.jobShortLink
        })
          .then(() => console.log('Successful share'))
          .catch((error) => console.log('Error sharing', error))
      }
    },
    handleInviteAll () {
      this.inviteMe = new Date()
    },
    // Honesty I don't like doing this, this favorite list should have been just an array with the ids, not this weird object. Maybe there's a reason for it, who knows.
    processFavorites (favorites) {
      return Object.keys(favorites).map(k => k).filter(item => item !== 'alive')
    },
    // the favorites will have to have a unique key to compare here.
    isSelected (item) {
      return this.invitedWorkers.some(el => {
        return el === item
      })
    },

    select (item) {
      // Here you can choose if you want to add the whole worker item or only the worker id, or maybe build your own worker object.
      if (this.invitedWorkers.some(el => {
        return el === item
      })) {
        this.invitedWorkers = this.invitedWorkers.filter(el => {
          return el !== item
        })
      } else {
        this.invitedWorkers.push(item)
      }
    },

    // inviteFav() {
    //   console.log(this.inviteList);
    //   var updates = {}

    //   Object.keys(this.inviteList).map(k => {
    //     console.log(k);
    //     updates[`/user/${k}/profile/jobInvites/${this.job._key}`] = true
    //   })
    //   console.log(updates);
    //   this.inviteDialog = false
    //   fb.database.ref().update(updates)
    // },

    async inviteWorkers () {
      this.status.loading = true
      this.status.error = false
      this.status.message = ''
      // When the button is clicked you run through the array and send the job invite to the selected workers.

      try {
        var updates = {}
        this.invitedWorkers.forEach(worker => {
          updates[`/user/${worker}/profile/jobInvites/${this.job._key}`] = {
            status: 'Invited',
            _key: this.job._key,
            invitedDate: new Date()
          }
          updates[`/jobs/${this.job._key}/applicants/${worker}/status`] = 'Invited'
        })
        fb.database.ref().update(updates)
        this.status.loading = false
        this.status.error = false
        this.status.message = 'All workers were invited!'
      } catch (error) {
        console.log(error)
        this.status.loading = false
        this.status.error = true
        this.status.message = 'There was an error inviting the workers. Please try again shortly.'
      }
    },

    // inviteFav() {
    //   console.log(this.inviteList);
    //   var updates = {}

    //   Object.keys(this.inviteList).map(k => {
    //     console.log(k);
    //     updates[`/user/${k}/profile/jobInvites/${this.job._key}`] = true
    //   })
    //   console.log(updates);
    //   this.inviteDialog = false
    //   fb.database.ref().update(updates)
    // },
    selectAll () {
      if (this.invitedWorkers.length !== this.processFavorites(this.favorites).length) {
        this.processFavorites(this.favorites).forEach(favorite => {
          if (!this.invitedWorkers.some(el => {
            return el === favorite
          })) {
            this.invitedWorkers.push(favorite)
          }
        })

        this.inviteWorkers()
      } else {
        this.invitedWorkers = []
      }
    }
  },

  filters: {
    acceptedApplicants (val) {
      return Object.keys(val).reduce(function (acc, key) {
        if (val[key] === 'Applied') {
          return acc + 1
        }
        return acc
      }, 0)
    }
  }
}
</script>
